import { Suspense, useEffect, useState } from "react";
import { getCategories } from "../../common/services/category.api";
import { ICategory } from "../../types/category.types";
import Loading from "../../common/components/ui/loading/Loading";
import {
  TableFilters,
  TableFiltersState,
} from "../../common/components/ui/table/TableFilters";
import GenericTable from "../../common/components/ui/table/GenericTable";
import { formatDateAndTime } from "../../common/helpers/date.helpers";
import TableFooter from "../../common/components/ui/table/TableFooter";
import ModalCreateCategory from "./components/modals/CreateCategory";

const EMPTY_ACTION = { eventName: "", data: undefined };
const headers = {
  name: "Descrição da Categoria",
};

export default function TableCategory() {
  const [categories, setCategories] = useState<ICategory[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [action, setAction] = useState<{ eventName: string; data?: unknown }>(
    EMPTY_ACTION
  );
  const [page, setPage] = useState<number>(1);
  const [data, setData] = useState({ itemsPerPage: 10, totalItems: 0 });
  const [filters, setFilters] = useState<TableFiltersState>({
    search: "",
    status: [],
    filterColumn: "",
    orderBy: "-updatedAt",
  });

  const handleFilterChange = (newFilters: Partial<TableFiltersState>) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      ...newFilters,
    }));
  };

  useEffect(() => {
    const fetchCategories = async (filters, page) => {
      if (action.eventName != "" && action.eventName != "created") {
        return;
      }

      setIsLoading(true);
      const result = await getCategories({ ...filters, page });
      setIsLoading(false);

      setCategories(result.data);
      setData({
        itemsPerPage: data.itemsPerPage,
        totalItems: result.totalItems as number,
      });
    };
    fetchCategories(filters, page);
  }, [action, filters, page, data.itemsPerPage]);

  const isAction = (eventName: string) => action.eventName === eventName;

  return (
    <Suspense fallback={<Loading />}>
      <div className="table-section">
        <TableFilters
          dashboardHeader="Categorias"
          placeholder="Digite a descrição."
          statusOptions={{}}
          newItemLabel="Nova Categoria"
          onNewItemClick={() =>
            setAction({ eventName: "create", data: undefined })
          }
          onSearch={handleFilterChange}
          entity="employee"
          tableData={categories}
        />

        <GenericTable
          headers={headers}
          data={categories}
          setFilters={({ orderBy }) => {
            setFilters((prevFilters) => ({
              ...prevFilters,
              orderBy,
            }));
          }}
          renders={
            {
              name: (name) => <p>{name as string}</p>,
              updatedAt: formatDateAndTime,
              createdAt: formatDateAndTime,
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } as any
          }
          entity="partners"
        />

        {isLoading && <Loading />}

        <TableFooter
          page={page || 1}
          totalItems={data.totalItems || 0}
          itemsPerPage={+(filters.itemsPerPage ?? 10)}
          goToPage={setPage}
        />
        {isAction("create") && (
          <ModalCreateCategory
            onClose={() => setAction({ eventName: "created" })}
          ></ModalCreateCategory>
        )}
      </div>
    </Suspense>
  );
}
